import React, { useEffect, useRef } from 'react';
export interface IProductVideoOverlayProps {
    isOpen: boolean;
    videoUrl?: string;
    onClose: () => void;
}

const ProductVideoOverlay: React.FC<IProductVideoOverlayProps> = ({ isOpen, videoUrl, onClose }) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        // Start playback when the overlay is mounted. The video is muted so
        // modern browsers can autoplay it without a user gesture.
        void videoRef.current?.play().catch(() => undefined);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = previousOverflow;
            videoRef.current?.pause();
        };
    }, [isOpen, onClose]);

    if (!isOpen || !videoUrl) {
        return null;
    }

    return (
        <div className='dobbies-product-video-overlay' role='dialog' aria-modal='true' aria-label='Product video'>
            <button
                type='button'
                className='dobbies-product-video-overlay__close'
                aria-label='Close product video'
                onClick={onClose}
            ></button>

            <video
                ref={videoRef}
                className='dobbies-product-video-overlay__video'
                src={videoUrl}
                controls
                autoPlay
                playsInline
                preload='auto'
            />
        </div>
    );
};

export default ProductVideoOverlay;
